import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41695a99"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "DialogPlaceHolder" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "DialogShade" }, null, -1))
const _hoisted_3 = {
  class: "D-Flex W-100 Events-None",
  style: {"min-height":"100vh","position":"relative","z-index":"3500"}
}
const _hoisted_4 = { class: "DialogBase" }
const _hoisted_5 = { class: "W-100 F1_5em F-Bold" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer W-100" }, null, -1))
const _hoisted_7 = {
  class: "W-100 D-Flex",
  style: {"flex-direction":"column"}
}
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = {
  key: 0,
  class: "F-CR F_75em",
  style: {"text-align":"start","margin":"0 1em"}
}
const _hoisted_10 = {
  class: "W-100 D-Flex",
  style: {"flex-direction":"column"}
}
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = {
  key: 0,
  class: "F-CR F_75em",
  style: {"text-align":"start","margin":"0 1em"}
}
const _hoisted_13 = { class: "W-100 D-Flex F_75em" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_15 = { class: "W-100 D-Flex F1em" }
const _hoisted_16 = { class: "W-100 D-Flex" }
const _hoisted_17 = {
  key: 0,
  style: {"min-height":"1em"},
  class: "M-Auto F-CR"
}
const _hoisted_18 = { class: "W-100 D-Flex F1em" }
const _hoisted_19 = { class: "W-100 D-Flex" }
const _hoisted_20 = {
  style: {"min-height":"1em"},
  class: "M-Auto F-CR"
}
const _hoisted_21 = {
  style: {"margin-top":"30px"},
  class: "W-100 D-Flex F1em"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesCheckBox = _resolveComponent("CookiesCheckBox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            onKeypress: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.SignIN && _ctx.SignIN(...args)), ["enter"])),
            class: "W-100 H-100 color3 F1_25em"
          }, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.LanguageSelector('Sign In', 'تسجيل الدخول')), 1),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass([{'ErrorBorder' : ((_ctx.Email.replace(/nbsp;/g, '').trim() === '' || !_ctx.Email) || (_ctx.UserNameServerErrors !== '')) && _ctx.ErrorsVisibilty}, "CookiesInput color2"]),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.Email) = $event)),
                placeholder: _ctx.LanguageSelector('Email', 'البريد الالكتروني')
              }, null, 10, _hoisted_8), [
                [_vModelText, _ctx.Email]
              ]),
              (_ctx.UserNameServerErrors !== '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.UserNameServerErrors), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass([{'ErrorBorder' : ((_ctx.Password.replace(/nbsp;/g, '').trim() === '' || !_ctx.Password) || (_ctx.PassServerErrors !== ''))  && _ctx.ErrorsVisibilty}, "CookiesInput color2"]),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.Password) = $event)),
                placeholder: _ctx.LanguageSelector('Password', 'كلمة السر'),
                type: "password"
              }, null, 10, _hoisted_11), [
                [_vModelText, _ctx.Password]
              ]),
              (_ctx.PassServerErrors !== '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.PassServerErrors), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_CookiesCheckBox, {
                style: {"margin-left":"1em","margin-top":"1em"},
                Res: "SignInRememberMe",
                Name: _ctx.LanguageSelector('Remember Me', 'تذكرني')
              }, null, 8, ["Name"])
            ]),
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                (_ctx.ErrorsVisibilty)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.Errors[0]), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.ServerError), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.SignIN && _ctx.SignIN(...args))),
                class: "M-Auto F1em",
                style: _normalizeStyle([{"color":"black"}, {background: _ctx.$store.getters.Theme.UserColors.third}])
              }, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.LanguageSelector('Sign In', 'تسجيل دخول')), 1)
              ], 4)
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}